import React, { Children, useState, useEffect } from 'react'
import Menu1 from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Modal, PageHeader } from 'antd';
import { Select } from 'antd';
import { Table } from 'antd';
import { DatePicker, Space } from 'antd'
import { useNavigate  } from 'react-router';
import { LoadBudgetSOM, approveorrejectbudgetplanner,GetAllMainCategoryList, LoadRemarksforBudget, ClearingSelectedBudgetTypeData } from './Actions/BudgetService';
import { useSelector, useDispatch } from 'react-redux';
import Cookie from "js-cookie";
import LZString from 'lz-string';

const { Option } = Select;
const { RangePicker } = DatePicker;

const BudgetPlannerSM = () => {
    const title = "Budget Planner Approval Process ZOMC";
    const jsonData = Cookie.get('currentUser');
              let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const statusInfo = useSelector(state=> state?.BudgetList?.StatusInfo)
    const StoresList = useSelector(state=> state?.BudgetList?.AllData?.StoresList)
    const  SelectedBudgetTypeData= useSelector(state=> state?.BudgetList?.BudgetPlannerSM?.SelectedBudgetTypeData)
    const RemarksData = useSelector(state => state?.BudgetList?.RemarksData)
    const [budgetData, setBudgetData] = useState([])
    const [IsRemarksModalOpen, setIsRemarksModalOpen] = useState(false);
    const [IsCommentsModalOpen, setIsCommentsModalOpen] = useState(false)
    const [IsConfirmModalOpen, SetIsConfirmModalOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [IsApprove, setIsApprove] = useState(false)
    const [IsSubmit, setIsSubmit] = useState(false)
    const [IsReject, setIsReject] = useState(false)
    const [budgetId, setBudgetId] = useState(null);
    const [year,setYear] = useState(null);
    const [storeId,setStoreId] = useState(null);
    const [isSearch, setIsSearch] = useState(false);
    const[arrIndex,setIndex]=useState(0)
    const [remarksData, setRemarksData] = useState('')

    const _doNavToBudgetPlannerApprovalZOMC = () => {
        navigate('/BudgetPlannerApprovalZOMC')
    }
    const _doOpenRejectModal = (e,record,index) => {
        setIndex(index)
        SetIsConfirmModalOpen(true)
        setIsModalOpen(true)
        setIsReject(true)
        setIsApprove(false)
        setIsSubmit(false)
    }
    const _doOpenSumitModal = () => {
        SetIsConfirmModalOpen(true)
        setIsModalOpen(true)
        setIsApprove(false)
        setIsSubmit(true)
        setIsReject(false)
    }
    
    const _doOpenConfirmModal = (e,record,index) => {
        setIndex(index)
        SetIsConfirmModalOpen(true)
        setIsModalOpen(true)
        setIsApprove(true)
        setIsReject(false)
        setIsSubmit(false)
    }

    
    const _doCloseConfirmModal = () => {
        console.log(arrIndex,"arrIndex")
        SetIsConfirmModalOpen(false)
        setIsModalOpen(false)
        setIsApprove(true)

    }
    const _doConfirmation = () =>{
        // console.log(arrIndex,"arrIndex")
        let data=[...budgetData];
        let result = {
            fedid : user['userId'],
            usertype:1,
            actiontype:1,
            remarks:remarksData,
            budget_id:Number(data[arrIndex].budget_id)
        }
        console.log(result,'result')
        dispatch(approveorrejectbudgetplanner(result))
        SetIsConfirmModalOpen(false)
        setIsModalOpen(false)
        setIsApprove(true)
        // console.log(statusInfo,'statusInfo inside confirm')
        // data[arrIndex]={...data[arrIndex],zomc_status:statusInfo?.statusmessage, remarks:remarksData}
        
        // setBudgetData(data)
    }
    useEffect(()=>{
        console.log(statusInfo,'statusInfo inside useEffect')
        let data = [...budgetData];
        data[arrIndex]={...data[arrIndex],zomc_status:statusInfo?.statusmessage, remarks:remarksData}
        setBudgetData(data)
    },[statusInfo])
    
    const handleReject = () =>{
        let data=[...budgetData];
        let result = {
            fedid : user['userId'],
            usertype:1,
            actiontype:2,
            remarks:remarksData,
            budget_id:data[arrIndex].budget_id
        }
        dispatch(approveorrejectbudgetplanner(result))
        console.log(arrIndex,'arrIndex')
        setIsReject(false)
        SetIsConfirmModalOpen(false)
        setIsModalOpen(false)
        
        // data[arrIndex]={...data[arrIndex],zomc_status:statusInfo?.statusmessage,remarks:remarksData}

        // console.log(result,'result inside handleReject')
        // console.log(data[arrIndex],'data[arrIndex]')
        // setBudgetData(data)
    }
    
    const _doOpenRemarksModal = (record) => {
        let data = {
            fedid: user['userId'],
            budgetid:record.budget_id
        }
        dispatch(LoadRemarksforBudget(data))
        setIsModalOpen(true);
        setIsRemarksModalOpen(true);
    }
    const _doCloseRemarksModal = () => {
        setIsModalOpen(false);
        setIsRemarksModalOpen(false)
    }
    const _doOpenCommentsModal = () => {
        setIsModalOpen(true);
        setIsCommentsModalOpen(true);
    }
    const _doCloseCommentsModal = () => {
        setIsModalOpen(false);
        setIsCommentsModalOpen(false)
    }


    const _doSelectVender = () => {

    }

    const TableData = [
        {
            SlNo: "1",
            EquipmentDetails: "Electrical",
            StoreName2021Budget: "150000",
            StoreName2021BudgetRealised: "160000",
            StoreName2022Budget: "12000",
            Percentage: "12.50%",
            CrisisBudget: "10000",
            StatusofZOMC: "Pending",
            Remarks: ""
        },
        {
            SlNo: "2",
            EquipmentDetails: "UPS",
            StoreName2021Budget: "12000",
            StoreName2021BudgetRealised: "12000",
            StoreName2022Budget: "19000",
            Percentage: "8.33%",
            CrisisBudget: "10000",
            StatusofZOMC: "Pending",
            Remarks: ""
        },
        {
            SlNo: "3",
            EquipmentDetails: "Stabilizer / Comac",
            StoreName2021Budget: "SAFETY",
            StoreName2021BudgetRealised: "12000",
            StoreName2022Budget: "19000",
            Percentage: "12.50%",
            CrisisBudget: "12000",
            StatusofZOMC: "Pending",
            Remarks: ""
        },
        {
            SlNo: "4",
            EquipmentDetails: "Power generator/DG",
            StoreName2021Budget: "SAFETY",
            StoreName2021BudgetRealised: "160000",
            StoreName2022Budget: "19000",
            Percentage: "12.50%",
            CrisisBudget: "12000",
            StatusofZOMC: "Pending",
            Remarks: ""
        },
        {
            SlNo: "5",
            EquipmentDetails: "Fire Fighting",
            StoreName2021Budget: "SAFETY",
            StoreName2021BudgetRealised: "160000",
            StoreName2022Budget: "19000",
            Percentage: "12.50%",
            CrisisBudget: "12000",
            StatusofZOMC: "Pending",
            Remarks: ""
        },
        {
            SlNo: "6",
            EquipmentDetails: "HVAC systems",
            StoreName2021Budget: "SAFETY",
            StoreName2021BudgetRealised: "160000",
            StoreName2022Budget: "19000",
            Percentage: "12.50%",
            CrisisBudget: "12000",
            StatusofZOMC: "Approved",
            Remarks: ""
        },
        {
            SlNo: "7",
            EquipmentDetails: "HVLS Fan",
            StoreName2021Budget: "SAFETY",
            StoreName2021BudgetRealised: "160000",
            StoreName2022Budget: "19000",
            Percentage: "12.50%",
            CrisisBudget: "12000",
            StatusofZOMC: "Rejected",
            Remarks: ""
        },
        {
            SlNo: "8",
            EquipmentDetails: "Lifts / Escalator",
            StoreName2021Budget: "SAFETY",
            StoreName2021BudgetRealised: "160000",
            StoreName2022Budget: "19000",
            Percentage: "12.50%",
            CrisisBudget: "12000",
            StatusofZOMC: "Pending",
            Remarks: ""
        },
        {
            SlNo: "9",
            EquipmentDetails: "Camera",
            StoreName2021Budget: "SAFETY",
            StoreName2021BudgetRealised: "160000",
            StoreName2022Budget: "19000",
            Percentage: "12.50%",
            CrisisBudget: "12000",
            StatusofZOMC: "Pending",
            Remarks: ""
        },
        {
            SlNo: "10",
            EquipmentDetails: "STP",
            StoreName2021Budget: "SAFETY",
            StoreName2021BudgetRealised: "160000",
            StoreName2022Budget: "19000",
            Percentage: "12.50%",
            CrisisBudget: "12000",
            StatusofZOMC: "Pending",
            Remarks: ""
        },
        {
            SlNo: "11",
            EquipmentDetails: "Roof",
            StoreName2021Budget: "SAFETY",
            StoreName2021BudgetRealised: "160000",
            StoreName2022Budget: "19000",
            Percentage: "12.50%",
            CrisisBudget: "12000",
            StatusofZOMC: "Pending",
            Remarks: ""
        },
        {
            SlNo: "12",
            EquipmentDetails: "Pest control",
            StoreName2021Budget: "SAFETY",
            StoreName2021BudgetRealised: "160000",
            StoreName2022Budget: "19000",
            Percentage: "12.50%",
            CrisisBudget: "12000",
            StatusofZOMC: "Pending",
            Remarks: ""
        }

    ]
    const [tableInfo,setTableInfo]=useState(TableData)
    const getComparePercetage = (record,index) =>{
        let previous_realised_budget = record.previous_realised_budget !=""? record.previous_realised_budget: 0
        let current_actual_budget = record.current_actual_budget !="" ? record.current_actual_budget : 0
        const result = (current_actual_budget-previous_realised_budget)/100
        return result;
        
    }
    // console.log(tableInfo,"tableInfotableInfo")
    const TableColumns = [

        {
            title: "Sl.No",
            dataIndex: "SlNo",
            key: "SlNo",
            render: (text, record,index) => (
                <Space size="middle">
                    {index+1}
                </Space>
            ),
        },
        {
            title: "Equipment Details",
            dataIndex: "main_category_name",
            key: "main_category_name"
        },
        {
            title: "Store Name 2021 Budget",
            dataIndex: "previous_actual_budget",
            key: "previous_actual_budget"
        },
        {
            title: "Store Name 2021 Budget Realised",
            dataIndex: "previous_realised_budget",
            key: "previous_realised_budget"
        },
        {
            title: "Store Name 2022 Budget",
            dataIndex: "current_actual_budget",
            key: "current_actual_budget"
        },
        {
            title: "Percentage (Comparison to last Year)",
            dataIndex: "Percentage",
            key: "Percentage",
            render:(text,record,index)=>{
                return(<input type='text' style={{ border: 'none' }} value={getComparePercetage(record,index)} disabled/>)
            }
        },
        {
            title: "2021 Crisis Budget(BCP)",
            dataIndex: "previous_realised_bcp_budget",
            key: "previous_realised_bcp_budget"
        },
        {
            title: "2022 Crisis Budget (BCP)",
            dataIndex: "current_actual_bcp_budget",
            key: "current_actual_bcp_budget"
        },
        {
            title: "ZOMC Status",
            dataIndex: "zomc_status",
            key: "zomc_status"
        },
        {
            title: "Remarks",
            dataIndex: "Remarks",
            key: "Remarks",
            render: (text, record) => (
                <Space size="middle">
                    <div className="table-icons">
                        <i onClick={()=>_doOpenRemarksModal(record)} className="fa fa-eye blue"></i>
                    </div>
                </Space>
            ),
        },
        {
            title: "Finance Team Status",
            dataIndex: "finanace_team_status",
            key: "finanace_team_status",
        },
        {
            title: "Action",
            dataIndex: "Action",
            key: "Action",
            render: (text, record,index) => (
                <Space size="middle">
                    <div className="table-icons">
                        { record.zomc_status == "Pending" &&<i onClick={(e)=>{_doOpenConfirmModal(e,record,index)}} className="fa fa-check green" ></i>}
                        {(record.finanace_team_status == "Reject" || record.zomc_status == "Pending")?<i onClick={(e)=>_doOpenRejectModal(e,record,index)} className="fa fa-times text-danger"></i>:""}
                    </div>
                </Space>
            ),
        }

    ]
    useEffect(()=>{
        setBudgetData(SelectedBudgetTypeData)
    },[SelectedBudgetTypeData])
    useEffect(()=>{
        dispatch(GetAllMainCategoryList());
        return()=>{
            dispatch(ClearingSelectedBudgetTypeData())
        }
    },[])
    const getYearOptions = ()=>{
        const presentYear = new Date().getFullYear();
        return [presentYear-2, presentYear-1, presentYear ]
    }
    const handleSearch = () => {
        setIsSearch(true);
        if(!budgetId) return
        else if(!storeId) return
        else if(!year) return
        let data = {
            fedid: user['userId'],
            budgettype:budgetId,
            storeid:storeId,
            budgetyear:year
        }
        dispatch(LoadBudgetSOM(data))
        setIsSearch(false);
    }
    const handleSubmit = () =>{
        console.log(budgetData,'budgetData')
        setBudgetData([])
    }
    return (
        <div className="wrapper">
            <Header title={title} />
            <Menu1 />
            {
                IsConfirmModalOpen === true ?
                    <Modal
                    open={isModalOpen} title="Confirmation"

                        footer={[
                            <div className="">
                                {
                                    IsReject == true ?
                                    <button type="submit" onClick={_doCloseConfirmModal} className='btn muted-button  deca-btn-orange btn-m-right' >Close</button>
                                    :
                                    <div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="exampleInput">Remarks*</label>
                                                <textarea className="form-control" onChange={(e)=> setRemarksData(e.target.value.replace(/[^\w\s]/gi, ""))} maxLength="1000"></textarea>
                                            </div>
                                        </div>
                                    </div> 
                                  <button type='button' onClick={_doCloseConfirmModal} className='btn muted-button  deca-btn-orange btn-m-right'>Cancel</button>
                                  <button type='button' onClick={_doConfirmation} className='btn btn-secondary  deca-btn-yellow'>Ok</button>
                                    </div>
                                }
                               
                            </div>
                        ]}
                    >
                        {
                            IsApprove === true && IsSubmit === false ?
                                <div className="">
                                    <h5>Are you sure you want to Approve</h5>
                                </div>
                                : null
                            
                        }
                        {
                            IsReject === true && IsSubmit === false ?
                            <div className="">
                                    <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label htmlFor="exampleInput">Remarks*</label>
                                            <textarea className="form-control" onChange={(e)=>setRemarksData(e.target.value.replace(/[^\w\s]/gi, ""))} maxLength="1000"></textarea>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <button type="submit" className="btn btn-secondary deca-btn-yellow" onClick={handleReject}>Submit</button>
                                    </div>
                                    </div> 
                            </div> :null
                        }
                        {
                            IsSubmit === true && IsApprove === false && IsReject === false ?
                            <div className="">
                                    <h5>Are you sure you want to Submit</h5>
                            </div>
                            : null
                        }

                    </Modal> : null

            }
            {
                IsRemarksModalOpen == true ?
                    <Modal
                    open={isModalOpen} title="Remarks"

                        footer={[
                            <button type='button' onClick={_doCloseRemarksModal} className='btn muted-button  deca-btn-orange'>Close</button>
                        ]}
                    >

                        <div className="">
                            {
                                (RemarksData?.length >1) ?
                                RemarksData?.map(ele=>{
                                    return(
                                        <ul className="remarks__list">
                                            <li className="remarks__item">
                                                <div className="remarks__userdetails">
                                                    <h5>{ele.created_by}</h5>
                                                    <h5>{ele.created_on}</h5>
                                                </div>
                                                <div className="remarks__reason">
                                                    <p>{ele.remarks}</p>
                                                </div>
                                            </li>
                                        </ul>
                                    )
                                })
                                : (RemarksData) && "Sorry No Remarks"
                            }
                        </div>
                    </Modal> : null
            }
            {
                IsCommentsModalOpen == true ?
                    <Modal
                    open={isModalOpen} title="Comments"

                        footer={[
                            <button type='button' onClick={_doCloseCommentsModal} className='btn muted-button  deca-btn-orange'>Close</button>
                        ]}
                    >

                        <div className="">
                            <ul className="remarks__list">
                                <li className="remarks__item">
                                    <div className="remarks__userdetails">
                                        <h5>Karthik</h5>
                                        <h5>On 12 Aug 2021 10:45 AM</h5>
                                    </div>
                                    <div className="remarks__reason">
                                        <p>Change date and time</p>
                                    </div>
                                </li>
                                <li className="remarks__item">
                                    <div className="remarks__userdetails">
                                        <h5>Karthik</h5>
                                        <h5>On 12 Aug 2021 10:45 AM</h5>
                                    </div>
                                    <div className="remarks__reason">
                                        <p>Change date and time</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Modal> : null
            }
            <div className='content-wrapper'>
                <section className='content top-space'>
                    <div className="m-panel">
                        <div className="m-panel__body p10">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor='exampleInput'>Year*</label>
                                        <Select className="form-control"
                                            showSearch
                                            allowClear={true}
                                            // onChange={_doSelectVender}
                                            onChange ={(value)=> (setYear(value),setBudgetData([]))}
                                            placeholder="-- Please Select --"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                                {
                                                getYearOptions().map((ele,index)=>{
                                                    return(
                                                        <Option key={index} value={ele}>{ele}</Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                        {(typeof(year)== "undefined" || year == null) && isSearch == true &&<span style={{color:'red'}}>Please Select Year</span> }
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor='exampleInput'>Budget Category*</label>
                                        <Select className="form-control"
                                            showSearch
                                            allowClear={true}
                                            // onChange={_doSelectVender}
                                            onChange ={(value)=> (setBudgetId(value),setBudgetData([]))}
                                            placeholder="-- Please Select --"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                                <Option value={1}>
                                                Preventive Maintenance
                                                </Option>
                                                <Option value={2}>
                                                Corrective Maintenance{" "}
                                                </Option>
                                                <Option value={3}>
                                                Maintenance Annual Expenses{" "}
                                                </Option>
                                                <Option value={4}>
                                                Maintenance Annual Investment{" "}
                                                </Option>
                                                <Option value={5}>Tpv Audit </Option>
                                                <Option value={6}>House Keeping </Option>
                                                <Option value={7}>
                                                Security Services{" "}
                                                </Option>
                                                <Option value={8}>
                                                Energy Other bills{" "}
                                                </Option>
                                        </Select>
                                        {(typeof(budgetId)== "undefined" || budgetId == null) && isSearch == true &&<span style={{color:'red'}}>Please Select Budget Category</span> }
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor='exampleInput'>Store*</label>
                                        <Select className="form-control"
                                            showSearch
                                            allowClear={true}
                                            onChange={(value)=>(setStoreId(value),setBudgetData([]))}
                                            value={storeId}
                                            placeholder="-- Please Select --"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            >
                                                {
                                                    StoresList?.map((ele,index)=>{
                                                        return(<Option key={index} value={ele.store_id}>{ele.store_name}</Option>)
                                                    })
                                                }
                                        </Select>
                                        {(typeof(storeId)== "undefined" || storeId == null) && isSearch == true &&<span style={{color:'red'}}>Please Select Store</span> }
                                    </div>
                                </div>
                                <div className="col-md-3 btn-no-lbl">
                                    <button type="button" className="btn btn-secondary btn-icon deca-btn-yellow"><i className="fa fa-search" onClick={handleSearch}></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="m-panel">
                        <div className="m-panel__body p10">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="maintanice_header">
                                        <div>
                                            {/* <span><h4 className="pre_header">Prevantive Maintaince Budget Planner</h4></span> */}
                                            <span><h4 className="pre_header">
                                                {
                                                (budgetId && typeof(year) !="undefined" && year) ?
                                                (budgetId == 1 ? `Prevantive Maintaince Budget- ${year}`:
                                                budgetId == 2 ? `Corrective Maintaince Budget- ${year}`:
                                                budgetId == 3 ? `Maintaince Annual Expenses- ${year}`:
                                                budgetId == 4 ? `Maintaince Annual Investment- ${year}`:
                                                budgetId == 5 ? `TPV Audit- ${year}`:
                                                budgetId == 6 ? `House Keeping- ${year}`:
                                                budgetId == 7 ? `Security Services- ${year}`:
                                                budgetId == 8 &&`Enery Other Bills- ${year}`):""
                                                }
                                            </h4></span>
                                        </div>
                                        {/* <div className="status_comments">
                                            <span className="text-right status"><h5>Status by Finance Team :  </h5>  Pending</span>
                                            <span className="text-right"><h5 onClick={_doOpenCommentsModal} className="text-primary">View Comment By FT</h5></span>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="m-table__main">
                                        <div className="m-table__responsive medium-width">
                                            <Table scroll={{ y: 300 }} pagination={false} columns={TableColumns} dataSource={budgetData}
                                                summary={ (pageData)  => {
                                                    let TotalBudgetRealised = 0;
                                                    let TotalBudget = 0;
                                                    let TotalPercentage = 0;
                                                    pageData.forEach(({ previous_realised_budget, current_actual_budget, Percentage }) => {
                                                        TotalBudgetRealised += Number(previous_realised_budget);
                                                        TotalBudget += Number(current_actual_budget);
                                                        TotalPercentage = (TotalBudget-TotalBudgetRealised)/100
                                                        // TotalPercentage += parseFloat(Percentage);
                                                    });
                                                    return (
                                                        <Table.Summary fixed>
                                                            <Table.Summary.Row>
                                                                <Table.Summary.Cell colSpan={3}>Total</Table.Summary.Cell>
                                                                <Table.Summary.Cell colSpan={1}>{TotalBudgetRealised}</Table.Summary.Cell>
                                                                <Table.Summary.Cell colSpan={1}>{TotalBudget}</Table.Summary.Cell>
                                                                <Table.Summary.Cell colSpan={1}>{TotalPercentage.toFixed(2)}%</Table.Summary.Cell>
                                                                <Table.Summary.Cell colSpan={7}></Table.Summary.Cell>
                                                            </Table.Summary.Row>
                                                        </Table.Summary>
                                                    )
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-12 text-right p10">
                                        <div className="m-page__button top-space">
                                            <button type='button' onClick={_doNavToBudgetPlannerApprovalZOMC} className='btn muted-button deca-btn-yellow color-red'>Cancel</button>
                                            {/* <button type='button' onClick={handleSubmit} className='btn btn-secondary deca-btn-yellow'>Submit</button> */}
                                            {/* s<button type='button' className='btn muted-button  deca-btn-orange color-blue'>Send To Finance</button> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    )
}

export default BudgetPlannerSM
